import {
  SEARCH_RESOURCES_START,
  SEARCH_RESOURCES_SUCCESS,
  SEARCH_RESOURCES_FAILED,
} from 'legacy/src/constants/types';
import { getResources } from '../utility/helpers';

const searchResources = (requestData) => async (dispatch) => {
  dispatch({
    type: SEARCH_RESOURCES_START,
  });
  try {
    const payload = await getResources(requestData);
    dispatch({
      type: SEARCH_RESOURCES_SUCCESS,
      payload: {
        resources: payload,
      },
    });
  } catch (error) {
    dispatch({
      type: SEARCH_RESOURCES_FAILED,
      payload: { errorMessage: error.message },
    });
  }
};

export default searchResources;
